import React, { useEffect, useState, createRef, useRef } from 'react';

import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import { ErrorPageStyle, getTextStyles, getImageStyles } from '../styles/ErrorPage/ErrorPage.styles';
import { Label, Spinner } from '@fluentui/react';
import { Text } from '@fluentui/react/lib/Text';
import { apiServices } from '../../services/ApiServices';
import { SendIcon, Chat, Avatar, AcceptIcon, Flex, Ref, Divider, Image } from '@fluentui/react-northstar';
import Component from '../../assets/Component 1.png';
import { ChatMessageItem } from '../../models/ChatStores';
import { getExpression, getHref, setExpression } from '../../utils/utils';
import moment from 'moment';
import {
  TransferCard
} from '../styles/StartScreen/SendBox.styles';
import {
  chatMessageStyle,
} from '../styles/StartScreen/ChatArea.styles';
export interface activeItemCreator {
  accessToken: any;
  channelUserId: string;
  displayName: string;
  tokenExpireOn: string;
  userAvatar: string;
  userId: string;
}
interface ChatAreaProps {
  isReverse: Boolean;
  data: activeItem | undefined;
}
export interface activeItem {
  comment: string;
  createAt: string;
  creator: activeItemCreator;
  csrUser: any;
  displayTicketId: string;
  fromChannel: string;
  id: string;
  lastModifiedBy: any;
  status: number;
  tenantId: string;
  toChannel: string;
  updateAt: string;
}

export default function ChattingRecords(props: ChatAreaProps) {
  const [chatMessages, setChatMessages] = useState<ChatMessageItem[]>([]);
  const createdRef: any = createRef();
  const messagesEnd = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  const [toBottomTip, setToBottomTip] = useState('返回底部');
  const [isShowToBottomTip, setIsShowToBottomTip] = useState(false);
  const [isOnload, setIsOnload] = useState(false);
  const [loadText, setLoadText] = useState('加载更多历史消息');


  const LoadHistoryMessages = async () => {
    let data = props.data;
    let isReverse = props.isReverse;
    if (data?.id) {
      let res = await apiServices.getHistoryForTicket({ limit: 50, offset: offset }, data?.id);

      let agentlist = await apiServices.listAgent();
      let result = res.result;
      result.map((item: any) => {
        if (item.messageType === 'Text' || item.messageType === 'Image') {
          item.content = JSON.parse(item.content);
        }
      });

      result = result
        .map((x: any) => ({
          id: x.id,
          avatar: data?.creator.userAvatar,
          body: x.content,
          userid: x.receiver,
          creator: x.creator,
          username: x.senderDisplayName,
          mine:
            x.messageType !== 'Text' && x.messageType !== 'Image'
              ? x.messageType
              : x.content.ChannelUserId === null
                ? 'support'
                : '',
          date: x.messageType !== 'Text' && x.messageType !== 'Image' ? x.createAt : x.clientArrivalTime,
          ticketId: x.ticketId,
          status: x.status === 1 ? x.status : x.ticketId !== x.ticketId ? 3 : x.status
        }))
        .reverse();
      // 区分当前单号
      let lastTicketId = 0;
      let currentInx = result.length;
      result.forEach((items: any, index: any) => {
        let currentAgent = agentlist.filter((agent: any) => {
          return items.creator === agent.userId;
        })[0];
        if (currentAgent) {
          items.avatar = currentAgent.avatar;
          items.username = currentAgent.displayName;
        }
        if (items.ticketId && lastTicketId !== items.ticketId) {
          currentInx = index;
        }
      });
      if (result.length === 0) {
        setLoadText('我也是有底线的');
      } else {
        setLoadText('加载更多历史消息');
      }
      let newResult = JSON.parse(JSON.stringify(result));
      if (newResult) {
        result.sort(function (a: any, b: any) {
          return moment(a.date).valueOf() - moment(b.date).valueOf();
        });
        result.forEach((item: any) => {
          item.date = moment(item.date).format('YYYY/MM/DD LT');
        });
      }

      const updatedMessages = await Promise.all(result.map(async (item: any) => {
        if (item.body?.MsgType === 1 && item.body?.Url) {
          const newUrl = await apiServices.getUrlWithSas(item.body.Url); // Fetch new URL
          item.body.Url = newUrl; // Update the item's URL
        }
        return item;
      }));

      (await isReverse)
        ? setChatMessages((s: any) => [...s, ...updatedMessages])
        : setChatMessages((s: any) => [...updatedMessages, ...s]);

      setIsOnload(true)
      setOffset((s) => {
        return (s + 50)
      })
    }
  };
  //返回底部效果
  const BackToBottom = () => {
    if (messagesEnd && messagesEnd.current) {
      const box = messagesEnd.current.getBoundingClientRect();
      setIsShowToBottomTip(box.bottom >= window.innerHeight);
      if (!(box.bottom >= window.innerHeight)) setToBottomTip('返回底部');
    }
  };
  useEffect(() => {
    LoadHistoryMessages();
  }, []);
  return (
    <Ref innerRef={createdRef}>
      {
        isOnload ? <div
          style={{
            flex: '1',
            overflow: 'auto',
            height: "100%",
            display: "flex",
            flexDirection: "column"
          }}
          onScroll={() => {
            BackToBottom();
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              fontSize: '12px',
              backgroundColor: 'rgb(245, 245, 245)'
            }}
          >
            {' '}
            <a
              style={loadText === '我也是有底线的' ? { color: '#888888' } : { color: '#5B5FC7' }}
              onClick={() => {
                LoadHistoryMessages();
              }}
            >
              {loadText}
            </a>{' '}
          </div>
          <Chat
            id="ChatBox"
            style={{

              background: '#F5F5F5',
              padding: '20px 108px',
              flex: "1",
              overflowY: "scroll"

            }}
            items={chatMessages.map((message: any, index: number) => {
              if (message.mine === 'CloseTicket' || message.mine === 'TransferTicket') {
                // // 转交工单聊天卡
                return {
                  children: (
                    <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                      <div key={index} className={TransferCard}>
                        <span>{message.username}</span> <span style={{ marginLeft: '10px' }}>{message.date} </span>
                        <div
                          style={{
                            display: 'flex',
                            backgroundColor: '#FBFBFB',
                            padding: '16px',
                            borderTop: 'solid 3px #6264A7',
                            overflow: 'hidden'
                          }}
                        >
                          {' '}
                          <div style={{ marginLeft: '14px', flex: '1' }}>
                            <b style={{ marginRight: '14px' }}>
                              {message.mine === 'CloseTicket' ? '工单关闭留言' : '工单转交留言'}
                            </b>
                            <div style={{ marginTop: '14px', whiteSpace: 'pre-line' }}>{message.body}</div>
                            <div style={{ borderTop: 'solid 1px #cccccc' }}>
                            </div>{' '}
                          </div>
                        </div>{' '}
                      </div>
                      <Avatar name="转接管理员" image={message.avatar ? message.avatar : Component} />{' '}
                    </div>
                  )
                };
              }
              else if (message.mine === '45C218B5-0CF1-4703-8272-4E863528A1E7') {
                return {

                  children: (
                    <Divider
                      content={
                        <div key={index}>
                          {JSON.parse(message.body).content}{' '}
                          {JSON.parse(message.body)?.msgCode == 1 ? (
                            <a title="非常感谢您的惠顾，后续有什么问题欢迎随时联系线上客服，祝您生活愉快">点击快捷回复</a>
                          ) : (
                            <></>
                          )}
                        </div>
                      }
                      color="#E9E7E6"
                      important
                    />
                  )
                };
              } else {
                return {
                  gutter:
                    message.mine === 'support' ? (
                      <Avatar
                        name={message.username}
                        image={message.avatar ? message.avatar : Component}
                      />
                    ) : (
                      <Avatar
                        name="游客"
                        image={message.avatar && message.avatar}
                        status={{
                          color: 'green',
                          icon: <AcceptIcon />
                        }}
                      />
                    ),
                  key: index,
                  contentPosition: message.mine === 'support' ? 'end' : 'start',
                  message: (
                    <Flex>
                      <Chat.Message
                        styles={chatMessageStyle(message.mine === 'support' ? true : false)}
                        content={
                          <Text style={{ whiteSpace: 'pre-wrap', maxWidth: '60%', boxSizing: 'border-box' }}>
                            {message.body?.MsgType === 0 ? (
                              <span
                                dangerouslySetInnerHTML={{ __html: getHref(getExpression(message.body.Content)) }}
                              ></span>
                            ) : (
                              ''
                            )}
                            {message.body?.MsgType === 1 ? (
                              <Image style={{ maxWidth: '400px' }} src={message.body.Url} />
                            ) : (
                              ''
                            )}
                          </Text>
                        }
                        author={''}
                        mine={message.mine}
                        timestamp={`${message.username || ''} ${message.date}`}
                      />
                    </Flex>
                  )
                };
              }
            })}
          />
          <div
            ref={messagesEnd}
            style={{ width: '100%', height: '2px', backgroundColor: 'rgb(245, 245, 245)' }}
          ></div>
        </div> :
          <div>
            <Spinner label="数据加载中，请稍等..." ariaLive="assertive" labelPosition="left" />
          </div>
      }

    </Ref>
  );
}
